import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useDeleteProcedureCatalog() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((procedureId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/procedures-catalog/${procedureId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
